import React, { useEffect } from 'react';
import FormPremium from './FormPremium';
import HandleAccount from './HandleAccount';
import './AccountSettings.css';

const AccountSettings = (props) => {

    useEffect(() => {
        if (props.role === 'basique') {
            document.getElementById("gerer-compte").classList.add("active");
            document.getElementById("gerer-compte-item").classList.add("active");
        }
    }, []);

    const openAccount = () => {
        window.open("https://www.boursedirect.fr/fr/bourse/ouvrir-un-compte","_blank");
    }

    const getParrainage = () => {
        window.open("https://www.boursedirect.fr/fr/offres/parrainage","_blank");
    }

    return (
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <div class="tuile tuile-default">
                        <div class="tuile-heading">
                            <h2 class="tuile-title"><span>Mon Profil Membre</span></h2>
                        </div>
                        <div class="tuile-body">
                            <ul class="nav nav-tabs" role="tablist">
                                {props.role === 'premium' ? <li role="presentation" class="active"><a href="#infos-perso" aria-controls="infos-perso" role="tab" data-toggle="tab">Informations personnelles</a></li> : null}
                                <li role="presentation" id="gerer-compte-item"><a href="#gerer-compte" aria-controls="gerer-compte" role="tab" data-toggle="tab">Gérer mon compte</a></li>
                                
                            </ul>
                            <div class="tab-content">
                                {props.role === 'premium' ? <div role="tabpanel" class="tab-pane active" id="infos-perso"><FormPremium /></div> : null}
                                <div role="tabpanel" class="tab-pane" id="gerer-compte"><HandleAccount role={props.role} /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <aside class="col-md-3">
                    <section class="row">
                        <div class="col-sm-6 col-md-12">
                            <button onClick={openAccount} class="btn btn-ouvcpt">
                                <span class="icon-ouvcpt"><i class="fa fa-user-plus" aria-hidden="true"></i></span>
                                <b>Ouvrir un compte</b>
                            </button>
                        </div>
                        <div class="col-sm-6 col-md-12">
                            <div class="tuile tuile-pub-1 align-center">
                                <p>Découvrez nos <br/> <strong>offres parrainnage</strong> <br/> dès maintenant !</p>
                                <button onClick={getParrainage} class="btn btn-default btn-aside-video"><b>En savoir plus</b></button>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div class="tuile tuile-help-aside"><p>En tant que membre, vous pouvez désormais réaliser vos <strong>analyses graphiques</strong> et les sauvegarder afin de faciliter votre réflexion.</p></div>
                        </div>
                    </section>
                </aside>
            </div>
        </div>
    )
}

export default AccountSettings;
